export default "__VITE_ASSET__BZHITiEc__"